export const isValidPhoneNumber = (phoneNo: string) => {
  return /^[689]\d{7}$/.test(phoneNo);
};
